<template>
  <div class="w-100">
    <div class="w-100 d-flex justify-content-between align-items-center">
      <h3 class="m-1 d-flex align-items-center">
        <feather-icon class="mr-25" size="22" icon="HomeIcon" />
        معلومات المقر الرئيسي
      </h3>
      <b-button
        :variant="!hq ? 'success' : 'primary'"
        @click="onUpdateHqClicked"
        v-if="canUpdateCriticalInfo"
        v-can="{ slug: $route.meta.slug, action: 'O' }"
      >
        <feather-icon icon="EditIcon" style="margin-left: 8px" />
        {{ !hq ? "إضافة" : "تعديل" }}
      </b-button>
    </div>
    <hr />
    <div class="w-100 text-center text-muted" v-if="!hq">
      لم يتم إضافة معلومات لمقر المنظمة بعد
    </div>
    <b-row v-else>
      <b-col cols="6">
        <info-card
          label="المحافظة"
          :value="hq.governorate ? hq.governorate.name_ar : ''"
        />
      </b-col>
      <b-col cols="6">
        <info-card label="العنوان" :value="hq.address" />
      </b-col>
      <b-col cols="6">
        <info-card
          label="رقم العقار"
          :value="hq.realEstate ? hq.realEstate.number : ''"
        />
      </b-col>
    </b-row>
    <form-modal
      title="معلومات المقر"
      v-model="hqModal"
      :formSchema="hqFormSchema"
      @confirm="onHqUpdateConfirmed"
      ref="hqModal"
    >
      <template #map="{ form }">
        <div class="d-flex w-100 align-items-center">
          <form-input
            readonly
            style="width: 42%"
            rules="required"
            label="خط الطول"
            v-model="form.longitude"
          />
          <form-input
            readonly
            class="mx-50"
            style="width: 42%"
            rules="required"
            label="خط العرض"
            v-model="form.latitude"
          />
          <b-button
            @click="openMapModal(form)"
            class="btn btn-primary mt-50"
            variant="flat-primary"
          >
            <feather-icon icon="MapPinIcon" />
          </b-button>
        </div>
        <b-modal
          v-model="mapModal"
          centered
          size="lg"
          title="موقع المقر"
          footer-class="removed"
          class="edit-modal"
          id="hqModal"
          static
        >
          <map-select
            ref="mapModal"
            @closeModal="mapModal = false"
            @markerUpdated="onLocationSelect($event, form)"
            :govsEndpoint.sync="govEp"
          />
          <!-- <b-row class="justify-content-end mt-1">
        <b-button @click="mapModal = false">إلغاء</b-button>
        <b-button variant="success" class="mx-1">تأكيد</b-button>
      </b-row> -->
        </b-modal>
      </template>
    </form-modal>
  </div>
</template>

<script>
import FormModal from "@/components/FormModal.vue";
import FormInput from "@/components/form-input";
import MapSelect from "@/components/map-select";
import InfoCard from "@/components/InfoCard.vue";
import { BRow, BCol, BButton } from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    InfoCard,
    BRow,
    BCol,
    BButton,
    FormModal,
    MapSelect,
    FormInput,
  },

  data() {
    return {
      hq: {},
      hqModal: false,
      mapModal: false,
      govEp: "v2/selects/governorates",
      hqFormSchema: {
        map: {
          key: "map",
        },
        real_estate_id: {
          component: "FormSelect",
          key: "real_estate_id",
          attrs: {
            id: "real-estate-number",
            label: "رقم العقار",
            rules: "required",
            ep: "v2/selects/real-estates?hq=true",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.number,
          },
        },
      },
    };
  },
  methods: {
    ...mapActions("NgoProfile/NgoInfo", ["editHq"]),
    openMapModal(form) {
      this.mapModal = true;
      if (this.hq)
        this.$nextTick(() => {
          this.$refs.mapModal.init({
            gov: this.hq.governorate.id,
            area: {
              ...this.hq.subDistrict,
              latitude: parseFloat(this.hq.latitude),
              longitude: parseFloat(this.hq.longitude),
            },
            address: this.hq.address,
          });
        });
    },
    onUpdateHqClicked() {
      if (this.hq)
        this.$refs.hqModal.init({
          longitude: this.hq.longitude,
          latitude: this.hq.latitude,
          real_estate_id: this.hq.realEstate ? this.hq.realEstate.id : null,
        });
      this.hqModal = true;
    },
    onLocationSelect({ pos, address, area, govId }, form) {
      this.$set(form, "longitude", pos.lng);
      this.$set(form, "latitude", pos.lat);
      this.$set(form, "address", address);
      this.$set(form, "governorate_id", govId);
      this.$set(form, "sub_district_id", area.id);
    },
    onHqUpdateConfirmed(form) {
      this.editHq(form);
    },
  },
  created() {
    this.hq = { ...this.ngoData.mainHQ };
  },
  computed: {
    ...mapGetters("NgoProfile", ["ngoData", "canUpdateCriticalInfo"]),
  },
};
</script>
